import { QueryClient } from '@tanstack/react-query';
import { createBrowserHistory, createRouter } from '@tanstack/react-router';

import { AtlasCore } from '@crossnokaye/typescript-sdk/core';

import { IAM } from '@/clients/iam';

import { AppConfigs } from './config';
import { routeTree } from './routeTree.gen';

/**
 * Creates an auth header provider function for APIs, used to get
 * an access token for the current user outside of the AuthProvider.
 */
export const authHeaderProvider = (() => {
  let tokenFn: () => Promise<string> = async () => '';

  return {
    set: (fn: () => Promise<string>) => {
      tokenFn = fn;
    },
    /**
     * Get the token with or without the Bearer prefix.
     * @param noPrefix - if true, return the token without the Bearer prefix.
     * @returns the token with or without the Bearer prefix.
     */
    get: async (noPrefix = false) => {
      const token = await tokenFn();
      return noPrefix ? token : `Bearer ${token}`;
    },
  };
})();

// Deal with development-mode hijinks (scripts have a different origin than the window)
// TODO: be a bit more paranoid about security i.e. check the document base?
const createHref = document.baseURI.startsWith(window.origin)
  ? undefined
  : (path: string) => `${window.origin}${path}`;
const history = createBrowserHistory({ createHref });
export const router = createRouter({ history, routeTree });

export const sdk = new IAM({ serverURL: AppConfigs.apiUrl.toString() });

export const atlasCore = new AtlasCore({
  oauth2HeaderAuthorization: () => authHeaderProvider.get(),
  serverURL: AppConfigs.apiUrl.toString(),
});

export const queryClient = new QueryClient();

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
